module.exports = __webpack_public_path__ + "assets/mvp-b26b6213c51880de975cc6109addeeb1.svg";